import { ArrowRight, Headphones, ShieldCheck, Smartphone, Zap } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./ElectronicsPromoBanner.css";

const ElectronicsPromoBanner = () => {
    const navigate = useNavigate();

    const handleExploreElectronics = () => {
        navigate("/Categories/Electronics");
    };

    return (
        <section className="electronics-promo">
            <div className="electronics-promo-container">
                <div className="electronics-promo-banner">
                    <img
                        src="/assets/images/banner/electronics-banner.jpg"
                        alt="Mobiles, electronics and smart accessories"
                    />
                    <div className="electronics-promo-overlay" />

                    <div className="electronics-promo-content">
                        <span className="electronics-promo-kicker">
                            SALAR ELECTRONICS
                        </span>

                        <h2>
                            Smarter tech for
                            <span>everyday life.</span>
                        </h2>

                        <p>
                            Discover the latest smartphones, smart devices and essential accessories built for performance, convenience and modern living.
                        </p>

                        <button
                            type="button"
                            className="electronics-promo-action"
                            onClick={handleExploreElectronics}
                        >
                            Explore Electronics
                            <ArrowRight size={16} strokeWidth={1.9} />
                        </button>
                    </div>

                    <div className="electronics-promo-features">
                        <div>
                            <span>
                                <Smartphone size={15} strokeWidth={1.9} />
                            </span>
                            <div>
                                <strong>Latest Mobiles</strong>
                                <small>New launches</small>
                            </div>
                        </div>

                        <div>
                            <span>
                                <Headphones size={15} strokeWidth={1.9} />
                            </span>
                            <div>
                                <strong>Smart Accessories</strong>
                                <small>Everyday essentials</small>
                            </div>
                        </div>

                        <div>
                            <span>
                                <Zap size={15} strokeWidth={2} />
                            </span>
                            <div>
                                <strong>Power & Performance</strong>
                                <small>Built for speed</small>
                            </div>
                        </div>

                        <div>
                            <span>
                                <ShieldCheck size={15} strokeWidth={1.9} />
                            </span>
                            <div>
                                <strong>Trusted Quality</strong>
                                <small>Reliable technology</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ElectronicsPromoBanner;